module.exports = __webpack_public_path__ + "static/img/telecomInfrastructur-right.1a4f6b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/medias/images/Sectors/telecomInfrastructur-right.png
// module id = 5mK9
// module chunks = 1